import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { NAVIGATION_ITEMS, CONTACT_INFO, SOCIAL_LINKS } from '../../utils/constants';

const Footer = ({ navigateTo }) => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4">Aether MindTech</h3>
            <p className="text-gray-300 mb-4">
              Building amazing digital experiences with modern web technologies.
            </p>
            <div className="flex space-x-4">
              {SOCIAL_LINKS.map((link, index) => (
                <a key={index} href={link.url} className="text-gray-300 hover:text-white transition-colors">
                  <span className="sr-only">{link.name}</span>
                  <div className={`w-6 h-6 ${link.bgColor} rounded`}></div>
                </a>
              ))}
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {NAVIGATION_ITEMS.map((item) => (
                <li key={item.key}>
                  <button 
                    onClick={() => navigateTo(item.key)} 
                    className="text-gray-300 hover:text-white transition-colors"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-2">
              <div className="flex items-center">
                <Mail size={16} className="mr-2" />
                <span className="text-gray-300">{CONTACT_INFO.email}</span>
              </div>
              <div className="flex items-center">
                <Phone size={16} className="mr-2" />
                <span className="text-gray-300">{CONTACT_INFO.phone}</span>
              </div>
              <div className="flex items-center">
                <MapPin size={16} className="mr-2" />
                <span className="text-gray-300">{CONTACT_INFO.address}</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-300">&copy; 2025 Aether MindTech. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;